var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdvance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_3151",
    x: 0,
    y: 0,
    width: 36,
    height: 36,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.102
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component_31_1",
    "data-name": "Component 31 \\u2013 1",
    transform: "translate(3 2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Component_29_2",
    "data-name": "Component 29 \\u2013 2"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -3, -2)",
    filter: "url(#Rectangle_3151)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3151-2",
    "data-name": "Rectangle 3151",
    width: 30,
    height: 30,
    rx: 15,
    transform: "translate(3 2)",
    fill: "#15b5d8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_33652",
    "data-name": "Group 33652",
    transform: "translate(-80.131 -249.227)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_2",
    "data-name": "Subtraction 2",
    d: "M8.605,14.389V13.258A6.15,6.15,0,0,0,7.254,1.107,6.18,6.18,0,0,0,1.108,7.256a6.107,6.107,0,0,0,1.244,3.711H1.023a7.252,7.252,0,1,1,7.583,3.42Z",
    transform: "translate(89.753 255.076)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_33637",
    "data-name": "Group 33637",
    transform: "translate(93.935 257.988)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_33636",
    "data-name": "Group 33636",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_143084",
    "data-name": "Path 143084",
    d: "M283.864,68.127h-.838a2.627,2.627,0,0,0-.363-.876h1.2a.626.626,0,0,0,0-1.251h-4.892a.626.626,0,0,0,0,1.251h1.4a1.5,1.5,0,0,1,1.333.876h-2.734a.626.626,0,0,0,0,1.251h2.734a1.99,1.99,0,0,1-.288.394,1.46,1.46,0,0,1-1.045.419h-1.4a.63.63,0,0,0-.626.638.646.646,0,0,0,.194.45l3.5,3.309a.624.624,0,1,0,.857-.907l-2.358-2.233a2.7,2.7,0,0,0,1.758-.782,2.8,2.8,0,0,0,.732-1.289h.838a.626.626,0,0,0,0-1.251Z",
    transform: "translate(-278.346 -66)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_143085",
    "data-name": "Path 143085",
    d: "M11.267,6.011,7.239,2.1a.355.355,0,0,0-.6.255V4.371A6.762,6.762,0,0,0,0,11.124a.35.35,0,0,0,.271.336.339.339,0,0,0,.084.01.374.374,0,0,0,.321-.191A6.045,6.045,0,0,1,5.964,8.162h.672v2.014a.355.355,0,0,0,.6.255l4.029-3.91a.355.355,0,0,0,0-.51Z",
    transform: "translate(86 261.907)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdvance);
export default __webpack_public_path__ + "static/media/Advance.611db54e4dc27164f553af6d83948c2d.svg";
export { ForwardRef as ReactComponent };